import { BaseFilterModel, DataGridFilter } from '../create-data-grid-filter';

export const stringFilterModelName = 'string_filter';

export type StringFilterModel = BaseFilterModel<
  string,
  typeof stringFilterModelName
>;

export type StringFilterParams = {
  /**
   * The name of the field for filtering in the server-side API
   */
  filterName: string;
  closeWhenChanged?: boolean;
  placeholder?: string;
};

type CreateStringFilterModelParams = {
  value: string;
  filterName: string;
};

export type StringDataGridFilter = DataGridFilter<
  StringFilterModel,
  StringFilterParams
>;

export const createStringFilterModel = ({
  value,
  filterName,
}: CreateStringFilterModelParams): StringFilterModel => {
  return {
    filterModelName: stringFilterModelName,
    value,
    filterName,
  };
};
